module.exports = __webpack_public_path__ + "img/hr-tree-02-b-trunk.bd6bb7a8.png";